import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=24b10acf&scoped=true&"
import script from "./Chart2.vue?vue&type=script&lang=js&"
export * from "./Chart2.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/dashboard/Chart2/Chart2Style.css?vue&type=style&index=0&id=24b10acf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b10acf",
  null
  
)

export default component.exports